import { useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useFileUpload } from './useFileUpload';
import { useFileRepoStore } from '../zustand/index';
import { InstantDb } from '../zustand/instant.schema';

export const useFileManager = () => {

    const { removeFile, files, addMetadata, addFile } = useFileRepoStore()

    const { uploadFile: uploadFn, isUploading, error, uploadProgress } = useFileUpload({ chatMode: true })

    const createFileMetadata = useCallback((file) => {
        const reference = uuidv4();
        const type = getFileType(file);
        return {
            id: uuidv4(),
            name: file.name,
            size: file.size,
            type,
            reference,
            status: 'pending',
            progress: 0
        };
    }, []);

    const getFileType = (file) => {
        if (!file.type) return 'other';
        const type = file.type;
        if (type.startsWith('image/')) return 'image';
        if (type.startsWith('video/')) return 'video';
        if (type.startsWith('audio/')) return 'audio';
        return 'document';
    }

    const handleFiles = useCallback((files) => {
        const newFiles = Array.from(files).map(file => {
            const metadata = createFileMetadata(file);
            addMetadata(metadata.reference, metadata);
            addFile(metadata.reference, file);
            return metadata;
        });
        return newFiles;
    }, [createFileMetadata]);

    const uploadFile = async (metadata, message) => {
        const file = files[metadata.reference];

        if (!file || !file.type) {
            return;
        };

        try {
            const type = getFileType(file);
            const { url } = await uploadFn({ file, type }, 0);
            if (!url) {
                return;
            }
            removeFile(metadata.reference);
            const allMeta = message.meta ?? [];

            allMeta.map((meta) => {
                if (meta.reference === metadata.reference) {
                    meta.link = url;
                    meta.status = 'completed';
                }
                return meta;
            })
            message.meta = allMeta;
            InstantDb.transact(InstantDb.tx.messages[message.id].update(message));

        } catch (error) {
            console.error('Upload failed:', error);
        }
    }

    return {
        handleFiles,
        uploadProgress,
        isUploading,
        error,
        uploadFile,
        removeFile,
    };
};